import AreaNames from "../../mixins/area-name-list-search";
import ChecklistSets from "../../mixins/checklist-sets-listing";

Vue.component("inspection-area-create-form", {

    mixins: [AreaNames, ChecklistSets],

    props: ["inspection"],

    data () {
        return {
            form: new AppForm({})
        };
    },

    computed: {

        modalTitle () {
            return this.form.name ? this.form.name : "New Area";
        }

    },

    mounted () {
        let self = this;

        Bus.$on("show-inspection-area-create-form", function () {
            self.showFormModal();
        });

        Bus.$on("hide-inspection-area-create-form", function () {
            self.hideFormModal();
        });

    },

    methods: {

        showFormModal () {
            this.loadChecklistSets();
            $("#modal-inspection-area-create-form").modal("show");
        },

        hideFormModal () {
            $("#modal-inspection-area-create-form").modal("hide");
        },

        create () {

            App.post("/inspections/" + this.inspection.id + "/areas/create", this.form)
            .then(response => {
                toastr.success("Area created!");
                this.form = new AppForm({});
                this.$emit("area-created", response);
            })
            .catch(() => {
                toastr.error("Error creating area!");
            });

        }

    }

});
